var map = {
	"./1.svg": 2910,
	"./10.svg": 3789,
	"./11.svg": 9135,
	"./12.svg": 8860,
	"./13.svg": 4220,
	"./14.svg": 5932,
	"./15.svg": 2006,
	"./16.svg": 7677,
	"./17.svg": 8410,
	"./18.svg": 7967,
	"./19.svg": 3886,
	"./2.svg": 7970,
	"./20.svg": 8929,
	"./21.svg": 813,
	"./22.svg": 9950,
	"./23.svg": 483,
	"./24.svg": 1095,
	"./3.svg": 8794,
	"./4.svg": 2526,
	"./5.svg": 4238,
	"./6.svg": 9848,
	"./7.svg": 6326,
	"./8.svg": 5537,
	"./9.svg": 6503,
	"./gameOver.svg": 8962,
	"./success.svg": 4495,
	"./victory.svg": 808
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8278;